import { render, staticRenderFns } from "./RecoveryView.vue?vue&type=template&id=07c7df24&scoped=true"
import script from "./RecoveryView.vue?vue&type=script&lang=js"
export * from "./RecoveryView.vue?vue&type=script&lang=js"
import style0 from "./RecoveryView.vue?vue&type=style&index=0&id=07c7df24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7df24",
  null
  
)

export default component.exports